module.exports = __webpack_public_path__ + "img/dadels-met-bacon-en-amandelen.a8bdcd05.jpeg";